// Chat API client — used by both the staff inbox and the clinic portal. JSON goes through the
// shared `api`; sending a message uses FormData (optional file) so it posts multipart.
import { api } from './api.ts';
import { API_PREFIX, type ChatThreadListItem, type ChatThreadDetail, type ChatThread, type ChatMessage } from '@alignova/shared';

export const chatApi = {
  threads: (status?: 'open' | 'closed') =>
    api.get<{ threads: ChatThreadListItem[] }>(`/chat/threads${status ? `?status=${status}` : ''}`),
  unread: () => api.get<{ total: number }>('/chat/unread'),
  thread: (id: string) => api.get<ChatThreadDetail>(`/chat/threads/${id}`),
  create: (body: { clinicId?: string | null; subject: string; department?: string | null; body?: string | null }) =>
    api.post<ChatThread>('/chat/threads', body),
  markRead: (id: string) => api.post(`/chat/threads/${id}/read`, {}),
  send: async (id: string, payload: { body?: string; file?: File | null }): Promise<ChatMessage> => {
    const fd = new FormData();
    if (payload.body) fd.append('body', payload.body);
    if (payload.file) fd.append('file', payload.file);
    const res = await fetch(`${API_PREFIX}/chat/threads/${id}/messages`, {
      method: 'POST',
      body: fd,
      credentials: 'include',
    });
    if (!res.ok) {
      const msg = await res.json().catch(() => ({ error: 'Failed to send' }));
      throw new Error((msg as { error?: string }).error ?? 'Failed to send');
    }
    return (await res.json()) as ChatMessage;
  },
  attachmentUrl: (threadId: string, messageId: string) =>
    `${API_PREFIX}/chat/threads/${threadId}/attachment/${messageId}`,
};
